import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, post, patch, del } from './agent';

// Activities are reached through a parent record (company, opportunity, or contact);
// the parent's own permissions gate the feed and mutations.
const pipelineActivities =
  (parentUrl) =>
  (id = '') => {
    const url = _([parentUrl, id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query, { multi: true }).toString(true))),
      upsert: (body) => (id ? patch : post)(url, body),
      delete: () => del(url),
    };
  };

export default pipelineActivities;
